package com.anjuros.website.templates.template4.components

import androidx.compose.runtime.Composable
import androidx.compose.runtime.mutableStateOf
import androidx.compose.runtime.remember
import androidx.compose.runtime.rememberCoroutineScope
import com.anjuros.website.components.shared.AnjurosImage
import com.anjuros.website.components.language.LocalText
import com.anjuros.website.templates.template4.modules.Template4Section
import com.anjuros.website.templates.template4.modules.Template4Theme
import com.anjuros.website.templates.template4.modules.getColor
import com.anjuros.website.templates.template4.styles.Template4AboutMeFontSizeStyle
import com.anjuros.website.templates.template4.styles.Template4AboutMeImageStyle
import com.anjuros.website.templates.template4.util.ResKey
import com.anjuros.website.templates.template4.util.Template4Constants
import com.anjuros.website.templates.template4.util.Template4ObserverViewportEntered
import com.anjuros.website.templates.template4.util.Template4Res
import com.varabyte.kobweb.compose.css.FontStyle
import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.ObjectFit
import com.varabyte.kobweb.compose.css.Transition
import com.varabyte.kobweb.compose.css.functions.LinearGradient
import com.varabyte.kobweb.compose.css.functions.linearGradient
import com.varabyte.kobweb.compose.foundation.layout.Box
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.modifiers.backgroundImage
import com.varabyte.kobweb.compose.ui.modifiers.border
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.color
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontStyle
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.margin
import com.varabyte.kobweb.compose.ui.modifiers.objectFit
import com.varabyte.kobweb.compose.ui.modifiers.opacity
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.compose.ui.modifiers.size
import com.varabyte.kobweb.compose.ui.modifiers.transition
import com.varabyte.kobweb.compose.ui.modifiers.translateY
import com.varabyte.kobweb.compose.ui.toAttrs
import com.varabyte.kobweb.silk.style.toModifier
import kotlinx.coroutines.delay
import kotlinx.coroutines.launch
import org.jetbrains.compose.web.css.LineStyle
import org.jetbrains.compose.web.css.ms
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.px
import org.jetbrains.compose.web.dom.P
import org.jetbrains.compose.web.dom.Text

@Composable
fun Template4AboutMeText(){
    val animatedOpacity= remember { mutableStateOf(0.0f) }



    Template4ObserverViewportEntered(
        sectionId = Template4Section.About_Me.id,
        distanceFromTop = 500.0
    ){
        animatedOpacity.value=1.0f
    }
    Box(){
        P(
            attrs = Template4AboutMeFontSizeStyle.toModifier()
                .padding(35.px)
                .align(Alignment.Center)
                .fontFamily(Template4Constants.FONT_FAMILY)
                .opacity(animatedOpacity.value)
                .transition(Transition.of(property = "opacity", duration = 1200.ms))
                .color(Template4Theme.Secondary.rgb)
                .fontWeight(FontWeight.Normal)
                .fontStyle(FontStyle.Italic)
                .toAttrs()
        ) {
            Text(LocalText(ResKey.TEMPLATE4_ABOUT))

        }
    }
}

@Composable
fun Template4AboutMeImage() {

    val animatedMargin= remember { mutableStateOf(40.percent) }
    val animatedOpacity= remember { mutableStateOf(0.0f) }

    val scope = rememberCoroutineScope()


    Template4ObserverViewportEntered(
        sectionId = Template4Section.About_Me.id,
        distanceFromTop = 500.0
    ){
        scope.launch {
            delay(300)
            animatedMargin.value=0.percent
            animatedOpacity.value=1.0f

        }
    }
    Box(modifier = Modifier
        .backgroundImage(
            linearGradient(
                Template4Theme.Primary.getColor(),
                Colors.White,
                LinearGradient.Direction.ToBottomRight
            )
        )){

        Box(modifier = Template4AboutMeImageStyle.toModifier()
            .align(Alignment.Center)
            .margin(20.px)
            .translateY(ty = animatedMargin.value)
            .opacity(animatedOpacity.value)
            .transition(
                Transition.of(property = "translate", duration = 1500.ms),
                Transition.of(property = "opacity", duration = 1000.ms))
           .borderRadius(150.px).align(Alignment.Center)){
            AnjurosImage(
                src = Template4Res.Image.template4_aboutme,
                alt = "Fast website setup for UK sole traders",
                modifier = Template4AboutMeImageStyle.toModifier()
                    .align(Alignment.Center)
                    .borderRadius(250.px).objectFit(ObjectFit.Cover)
            )

        }

}


}

@Composable
fun Template4AboutMeImageSmall() {
    val animatedOpacity= remember { mutableStateOf(0.0f) }



    Template4ObserverViewportEntered(
        sectionId = Template4Section.About_Me.id,
        distanceFromTop = 400.0
    ){
        animatedOpacity.value=1.0f
    }

    Box(modifier = Modifier.fillMaxWidth()) {
        AnjurosImage(
            src = Template4Res.Image.template4_aboutme,
            alt = "Best websites for sole traders in the UK",
            modifier = Modifier.align(Alignment.Center)
                .size(150.px).opacity(animatedOpacity.value)
                .transition(Transition.of(property = "opacity", duration = 2500.ms))
                .borderRadius(150.px).objectFit(ObjectFit.Cover)
                .border(
                    width = 2.px,
                    color = Template4Theme.Primary.getColor(),
                    style = LineStyle.Solid
                )
        )
    }
}